









































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { ExtendedProjectModel, EProjectType } from "../models";
import FileFilter from "../components/FileFilter.vue";
import FileList from "../components/FileList.vue";
import ProjectInfo from "../components/ProjectInfo.vue";
import StatBlocksManagement from "../components/StatBlocksManagement.vue";
import StatBlocksRenting from "../components/StatBlocksRenting.vue";
import { FileEntryModel } from "../models/fileEntry";
import SubProjectList from "../components/SubProjectList.vue";

const pStore = namespace("projects");
const snackStore = namespace("snackbar");

@Component({
  components: {
    FileFilter,
    FileList,
    ProjectInfo,
    StatBlocksManagement,
    StatBlocksRenting,
    SubProjectList,
  },
})
export default class Project extends Vue {
  @pStore.Getter buyProject!: (id: number) => ExtendedProjectModel;
  @pStore.Getter fileEntries!: (id: number) => FileEntryModel[];
  @pStore.Action fetchBuyProject!: (id: number) => Promise<void>;
  @pStore.Action fetchFileEntriesForBuyProject!: (id: number) => Promise<void>;
  @snackStore.Mutation defaultError!: () => void;

  private filteredFiles: FileEntryModel[] = [];
  private loaded = false;
  private EProjectType: typeof EProjectType = EProjectType;

  get projectID(): number {
    return Number(this.$route.params.id);
  }

  get project(): ExtendedProjectModel {
    return this.buyProject(this.projectID);
  }

  get files(): FileEntryModel[] {
    return this.fileEntries(this.projectID);
  }

  @Watch("project")
  private onProject(p: ExtendedProjectModel) {
    this.$emit("title", p.description);
  }

  async mounted(): Promise<void> {
    try {
      await Promise.all([
        this.fetchFileEntriesForBuyProject(this.projectID),
        this.fetchBuyProject(this.projectID),
      ]);
    } catch (e) {
      this.defaultError();
    }
    this.loaded = true;
  }
}
